import { useCallback } from "react";

import { dealNetworkService } from "@/api/dealNetwork";
import { ConnectRequestConfirmationPage } from "@/pages/PublicConnect/ConnectRequestConfirmationPage";

type TFundraiserConnectPageProps = {
  connectRequestId?: string;
};

export function FundraiserConnectPage({ connectRequestId }: TFundraiserConnectPageProps) {
  const confirmRequest = useCallback(
    (connectRequest: string) => dealNetworkService.createConnectRequestIntroduction(connectRequest),
    []
  );

  return (
    <ConnectRequestConfirmationPage
      connectRequestId={connectRequestId}
      confirmRequest={confirmRequest}
    />
  );
}
